import React, { useState, useEffect } from "react";
import Sidebar from "../components/sidebar";
import Card from "react-bootstrap/Card";
import { Nav, Tab, Row, Col } from "react-bootstrap";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import Cargando from "../components/cargando";
import SinPermisos from "./../components/sinpermisos";
import "./Misdatos.css";

const url = "https://api.mrcirp.com/public/infocreador";
const urlCampañas = "https://api.mrcirp.com/public/infocampanas";
const urlCampañasAudiencia = "https://api.mrcirp.com/public/campanas-audiencia";

const Misdatosuser = () => {
  // Datos de Usuario Logueado
  const [users, setUsers] = useState([]);
  const [campañas, setCampañas] = useState([]);
  const [campañasAudiencia, setCampañasAudiencia] = useState([]);
  const [campañaSeleccionada, setCampañaSeleccionada] = useState(null);
  const [tipoCampañaSeleccionada, setTipoCampañaSeleccionada] = useState(null); // 'video' o 'audiencia'
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // Datos editables
 const [formData, setFormData] = useState({
  id: "",
  correo: "",
  whatsapp: "",
  instagram: "",
  facebook: "",
  linkedin: "",
  tiktok: "",
  calendly: "",
  pdf: "",
  texto_modal: "" // Asegúrate que coincida con el backend
});

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
      obtenerCampañas(user.id);
      obtenerCampañasAudiencia(user.id);
    }
  }, []);

  const obtenerCampañas = async (userId) => {
    setLoading(true);
    try {
      const response = await axios.get(url + "/" + userId);
      setCampañas(response.data);
    } catch (err) {
      setError("Error al obtener las campañas de video");
    } finally {
      setLoading(false);
    }
  };

  const obtenerCampañasAudiencia = async (userId) => {
    try {
      const response = await axios.get(urlCampañasAudiencia);
      // Filtrar campañas de audiencia por el usuario logueado
      const campañasDelUsuario = response.data.filter(campaña => 
        campaña.admin_id === userId || campaña.creador === userId
      );
      setCampañasAudiencia(campañasDelUsuario);
    } catch (err) {
      console.error("Error al obtener las campañas de audiencia:", err);
      setCampañasAudiencia([]);
    }
  };

  const cargarDatosCampaña = async (usuarioCampaña) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(urlCampañas + "/" + usuarioCampaña);
      if (response.data && response.data.length > 0) {
        const { password, ...datosSinClave } = response.data[0];
        setFormData({
          ...datosSinClave,
          whatsapp: datosSinClave.whatsapp || '',
          texto_modal: datosSinClave.texto_modal || ''
        });
      }
    } catch (err) {
      setError("Error al cargar los datos de la campaña");
    } finally {
      setLoading(false);
    }
  };

  const cargarDatosCampañaAudiencia = async (campaña) => {
    setLoading(true);
    setError(null);
    try {
      // Para campañas de audiencia, usamos los datos directamente
      setFormData({
        id: campaña.id,
        correo: campaña.correo || '',
        whatsapp: campaña.whatsapp || '',
        instagram: campaña.instagram || '',
        facebook: campaña.facebook || '',
        linkedin: campaña.linkedin || '',
        tiktok: campaña.tiktok || '',
        calendly: campaña.calendly || '',
        pdf: campaña.pdf || '',
        texto_modal: campaña.texto_modal || ''
      });
    } catch (err) {
      setError("Error al cargar los datos de la campaña de audiencia");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectCampaña = (campaña, tipo) => {
    setCampañaSeleccionada(campaña);
    setTipoCampañaSeleccionada(tipo);
    if (tipo === 'video') {
      cargarDatosCampaña(campaña.usuario);
    } else if (tipo === 'audiencia') {
      cargarDatosCampañaAudiencia(campaña);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError(null);
  setSuccess(false);
  
  try {
    console.log("Enviando datos:", formData); // Para debug
    
    let response;
    if (tipoCampañaSeleccionada === 'video') {
      response = await axios.put(`${urlCampañas}/${formData.id}`, formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
    } else if (tipoCampañaSeleccionada === 'audiencia') {
      response = await axios.put(`${urlCampañasAudiencia}/${formData.id}`, formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    
    if (response.data.success) {
      setSuccess(true);
      if (tipoCampañaSeleccionada === 'video') {
        cargarDatosCampaña(campañaSeleccionada.usuario);
      } else {
        cargarDatosCampañaAudiencia(campañaSeleccionada);
      }
    } else {
      setError(response.data.message || "Error al actualizar los datos");
    }
  } catch (err) {
    console.error("Error completo:", err.response); // Para debug
    setError(err.response?.data?.message || "Error al actualizar los datos");
  } finally {
    setLoading(false);
  }
};

  const volverACampañas = () => {
    setCampañaSeleccionada(null);
    setTipoCampañaSeleccionada(null);
    setFormData({
      id: "",
      correo: "",
      whatsapp: "",
      instagram: "",
      facebook: "",
      linkedin: "",
      tiktok: "",
      calendly: "",
      pdf: "",
      texto_modal: ""
    });
  };

  if (users.rol !== undefined && users.rol !== "cliente") {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }

  return (
    <div className="Categorias">
      <Sidebar>
        <Card>
          <Card.Header className="bg-dark text-white" as="h5">
            <div className="d-flex justify-content-between align-items-center">
              {campañaSeleccionada ? (
                <>
                  <button 
                    onClick={volverACampañas} 
                    className="btn btn-sm btn-outline-light mr-2"
                  >
                    <FaIcons.FaArrowLeft />
                  </button>
                  <span>
                    Editando: {tipoCampañaSeleccionada === 'video' ? campañaSeleccionada.usuario : campañaSeleccionada.nombre_campana}
                    <span className="badge bg-secondary ms-2">
                      {tipoCampañaSeleccionada === 'video' ? 'Video' : 'Audiencia'}
                    </span>
                  </span>
                </>
              ) : (
                <span>Mis Campañas</span>
              )}
            </div>
          </Card.Header>
          
          <Card.Body>
            {loading && <Cargando />}
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">Datos actualizados correctamente!</div>}

            {!campañaSeleccionada ? (
              <>
                <Card.Title>Seleccione una campaña para editar</Card.Title>
                <p>Listado de campañas asociadas a su cuenta.</p>
                
                <Tab.Container defaultActiveKey="video">
                  <Nav variant="tabs" className="mb-4">
                    <Nav.Item>
                      <Nav.Link eventKey="video">
                        <FaIcons.FaVideo className="me-2" />
                        Campañas de Video ({campañas.length})
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="audiencia">
                        <FaIcons.FaUsers className="me-2" />
                        Campañas de Audiencia ({campañasAudiencia.length})
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>

                  <Tab.Content>
                    <Tab.Pane eventKey="video">
                      {campañas.length === 0 ? (
                        <div className="alert alert-info">No tienes campañas de video registradas</div>
                      ) : (
                        <div className="campaigns-container">
                          <div className="row">
                            {campañas.map(campaña => (
                              <div key={campaña.id} className="col-lg-4 col-md-6">
                              <Card 
                                onClick={() => handleSelectCampaña(campaña, 'video')}
                                className="campaign-card h-100"
                                style={{ cursor: 'pointer' }}
                              >
                                <Card.Body className="text-center d-flex flex-column justify-content-center">
                                  <Card.Title className="campaign-title">
                                    <FaIcons.FaVideo className="me-2 text-primary" />
                                    {campaña.usuario}
                                  </Card.Title>
                                  <Card.Text>
                                    <span className={`campaign-badge ${campaña.estado === 'activo' ? 'bg-success' : 'bg-secondary'} text-white`}>
                                      {campaña.estado}
                                    </span>
                                  </Card.Text>
                                </Card.Body>
                                <Card.Footer className="text-muted text-center">
                                  <small>Haz clic para editar</small>
                                </Card.Footer>
                              </Card>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </Tab.Pane>

                    <Tab.Pane eventKey="audiencia">
                      {campañasAudiencia.length === 0 ? (
                        <div className="alert alert-info">No tienes campañas de audiencia registradas</div>
                      ) : (
                        <div className="campaigns-container">
                          <div className="row">
                            {campañasAudiencia.map(campaña => (
                              <div key={campaña.id} className="col-lg-4 col-md-6">
                              <Card 
                                onClick={() => handleSelectCampaña(campaña, 'audiencia')}
                                className="campaign-card h-100"
                                style={{ cursor: 'pointer' }}
                              >
                                <Card.Body className="text-center d-flex flex-column justify-content-center">
                                  <Card.Title className="campaign-title">
                                    <FaIcons.FaUsers className="me-2 text-info" />
                                    {campaña.nombre_campana}
                                  </Card.Title>
                                  <Card.Text>
                                    <span className="campaign-badge bg-primary text-white mb-2">
                                      {campaña.tipo_campana || 'Audiencia'}
                                    </span>
                                  </Card.Text>
                                  <Card.Text className="campaign-link">
                                    <FaIcons.FaLink className="me-1" />
                                    {campaña.enlace_campana}
                                  </Card.Text>
                                </Card.Body>
                                <Card.Footer className="text-muted text-center">
                                  <small>Haz clic para editar</small>
                                </Card.Footer>
                              </Card>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Texto de la modal</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          name="texto_modal"
                          value={formData.texto_modal || ''}
                          onChange={handleChange}
                        />
                        <span className="input-group-text">
                          <FaIcons.FaPen />
                        </span>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Correo</label>
                      <div className="input-group">
                        <input
                          type="email"
                          className="form-control"
                          name="correo"
                          value={formData.correo}
                          onChange={handleChange}
                          required
                        />
                        <span className="input-group-text">
                          <FaIcons.FaPen />
                        </span>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Teléfono WhatsApp</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          name="whatsapp"
                          value={formData.whatsapp}
                          onChange={handleChange}
                          placeholder="Ejemplo: 50661015882 sin +"
                        />
                        <span className="input-group-text">
                          <FaIcons.FaPen />
                        </span>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Instagram</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          name="instagram"
                          value={formData.instagram}
                          onChange={handleChange}
                          placeholder="Usuario sin @"
                        />
                        <span className="input-group-text">
                          <FaIcons.FaInstagram />
                        </span>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Calendly</label>
                      <div className="input-group">
                        <input
                          type="url"
                          className="form-control"
                          name="calendly"
                          value={formData.calendly}
                          onChange={handleChange}
                          placeholder="https://calendly.com/tu-usuario"
                        />
                        <span className="input-group-text">
                          <FaIcons.FaCalendarAlt />
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Facebook</label>
                      <div className="input-group">
                        <input
                          type="url"
                          className="form-control"
                          name="facebook"
                          value={formData.facebook}
                          onChange={handleChange}
                          placeholder="URL de perfil"
                        />
                        <span className="input-group-text">
                          <FaIcons.FaFacebook />
                        </span>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">LinkedIn</label>
                      <div className="input-group">
                        <input
                          type="url"
                          className="form-control"
                          name="linkedin"
                          value={formData.linkedin}
                          onChange={handleChange}
                          placeholder="URL de perfil"
                        />
                        <span className="input-group-text">
                          <FaIcons.FaLinkedin />
                        </span>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">TikTok</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          name="tiktok"
                          value={formData.tiktok}
                          onChange={handleChange}
                          placeholder="Usuario sin @"
                        />
                        <span className="input-group-text">
                          <FaIcons.FaTiktok />
                        </span>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">PDF</label>
                      <div className="input-group">
                        <input
                          type="url"
                          className="form-control"
                          name="pdf"
                          value={formData.pdf}
                          onChange={handleChange}
                          placeholder="https://ejemplo.com/documento.pdf"
                        />
                        <span className="input-group-text">
                          <FaIcons.FaFilePdf />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  <button 
                    type="submit" 
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? 'Guardando...' : 'Guardar Cambios'}
                  </button>
                </div>
              </form>
            )}
          </Card.Body>
        </Card>
      </Sidebar>
    </div>
  );
};

export default Misdatosuser;